var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnimalIdentity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.46331 9.58337C5.38331 10.5467 6.10998 11.3334 7.07665 11.3334H8.67331C9.75998 11.3334 10.5066 10.4567 10.3266 9.38337C10.1366 8.25671 9.04998 7.33337 7.90665 7.33337C6.66665 7.33337 5.56665 8.34671 5.46331 9.58337Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.333333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48336 6.50004C7.9436 6.50004 8.31669 6.12694 8.31669 5.66671C8.31669 5.20647 7.9436 4.83337 7.48336 4.83337C7.02312 4.83337 6.65002 5.20647 6.65002 5.66671C6.65002 6.12694 7.02312 6.50004 7.48336 6.50004Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76 6.89998C10.1282 6.89998 10.4267 6.60151 10.4267 6.23332C10.4267 5.86513 10.1282 5.56665 9.76 5.56665C9.39181 5.56665 9.09334 5.86513 9.09334 6.23332C9.09334 6.60151 9.39181 6.89998 9.76 6.89998Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.416667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9933 8.2334C11.2695 8.2334 11.4933 8.00954 11.4933 7.7334C11.4933 7.45726 11.2695 7.2334 10.9933 7.2334C10.7172 7.2334 10.4933 7.45726 10.4933 7.7334C10.4933 8.00954 10.7172 8.2334 10.9933 8.2334Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.416667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31669 7.56673C5.68488 7.56673 5.98336 7.26825 5.98336 6.90007C5.98336 6.53188 5.68488 6.2334 5.31669 6.2334C4.9485 6.2334 4.65002 6.53188 4.65002 6.90007C4.65002 7.26825 4.9485 7.56673 5.31669 7.56673Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.416667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.33337H11.3333C13.3333 1.33337 14.6667 2.66671 14.6667 4.66671V6.00004",
    stroke: "#8E8E8E",
    strokeWidth: 0.566667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 6.00004V4.66671C1.33333 2.66671 2.66666 1.33337 4.66666 1.33337H5.99999",
    stroke: "#8E8E8E",
    strokeWidth: 0.566667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.6667H11.3333C13.3333 14.6667 14.6667 13.3333 14.6667 11.3333V10",
    stroke: "#8E8E8E",
    strokeWidth: 0.566667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 10V11.3333C1.33333 13.3333 2.66666 14.6667 4.66666 14.6667H5.99999",
    stroke: "#8E8E8E",
    strokeWidth: 0.566667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimalIdentity);
export default __webpack_public_path__ + "static/media/AnimalIdentity.553c6564f9ab372850f301d613445512.svg";
export { ForwardRef as ReactComponent };